/** @jsxRuntime classic */
/** @jsx jsx */
//@ts-nocheck
import { jsx } from '@emotion/react';

import colors from '../css/colors';

const textareaStyles = {
  width: '100%',
  background: '#F6F6F6',
  marginTop: '10px',
  border: `1px solid ${colors.grey300}`,
  display: 'block',
  borderRadius: 4,
  backgroundColor: '#fff',
  height: 96,
  resize: 'none',
  caretColor: colors.orange100,
  '::placeholder': {
    color: colors.grey400,
  },
  ' :focus': {
    outline: `1px solid ${colors.orange100}`,
  },
};

const TextArea = ({
  error,
  label,
  value,
  placeholder,
  onChange,
  styles = {},
  divStyles = {},
  onBlur = () => {},
  onPaste = () => {},
  name = ''
}) => {
  return (
    <div css={divStyles}>
      {error ||
        (label && (
          <div
            css={{
              marginBottom: 8,
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            {label && <span css={{ display: 'inline-block' }}>{label}</span>}
            {error && <span css={{ color: colors.hudsonRed }}>Error</span>}
          </div>
        ))}
      <textarea
        css={[textareaStyles, styles]}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onBlur={onBlur}
        onPaste={onPaste}
        name={name}
      ></textarea>
    </div>
  );
};

export default TextArea;
